import { __assign, __awaiter, __generator, __read } from "tslib";
import { ThemeContext_unstable } from '@fluentui/react-shared-contexts';
import { historyEntryDecorator } from '../utils';
import { getLoggerSettings } from '.';
export function getMainSettings(searchInstrumenter, searchSettings) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, loggerSettings, instrumenter, identity, userEntitlements, officeContext, sharedContext, searchConfig, hostAppId, environment, isSubscribedUser, enableDebugOutput, fastBingAnswerResultsEnabled, fastEnableQueryRules, fastUseSubstrateEnabled, searchInHeaderEnabled, serpSpellCheckEnabled, preferredCulture, officeMarketLcid, userPrincipalName, isMsa, SharePointResourceId, isPwaInUwp, rootPath, flights3s, baseMainSettings, enterpriseMainSettings, consumerMainSettings;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        getLoggerSettings(searchSettings.getSearchConfig()),
                        searchInstrumenter.getModule(),
                        searchSettings.getIdentity(),
                        searchSettings.getUserEntitlements(),
                        searchSettings.getOfficeComponentContext(),
                        searchSettings.getSharedContext(),
                        searchSettings.getSearchConfig(),
                        searchSettings.getHostAppId(),
                        searchSettings.getSearchEnvironment(),
                        searchSettings.getIsSubscribedUser(),
                    ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 10]), loggerSettings = _a[0], instrumenter = _a[1], identity = _a[2], userEntitlements = _a[3], officeContext = _a[4], sharedContext = _a[5], searchConfig = _a[6], hostAppId = _a[7], environment = _a[8], isSubscribedUser = _a[9];
                    enableDebugOutput = false;
                    fastBingAnswerResultsEnabled = searchConfig.fastBingAnswerResultsEnabled, fastEnableQueryRules = searchConfig.fastEnableQueryRules, fastUseSubstrateEnabled = searchConfig.fastUseSubstrateEnabled, searchInHeaderEnabled = searchConfig.searchInHeaderEnabled, serpSpellCheckEnabled = searchConfig.serpSpellCheckEnabled;
                    preferredCulture = officeContext.preferredCulture;
                    officeMarketLcid = sharedContext.officeMarketLcid;
                    userPrincipalName = identity.userPrincipalName, isMsa = identity.isMsa;
                    SharePointResourceId = userEntitlements.SharePointResourceId, isPwaInUwp = userEntitlements.isPwaInUwp;
                    rootPath = officeContext.rootPath || '';
                    flights3s = [];
                    // Check to see if the DYM feature is enabled and add the flight header for 3S if true
                    if (serpSpellCheckEnabled) {
                        flights3s.push('SPOBingSpeller');
                    }
                    baseMainSettings = {
                        'searchux.answerBlock': fastBingAnswerResultsEnabled,
                        'searchux.answerBlockExperiment': fastBingAnswerResultsEnabled,
                        'searchux.api.sharePoint.url': SharePointResourceId || '',
                        'searchux.BoxInTheSuiteNavExperiment': searchInHeaderEnabled,
                        'searchux.clientId': hostAppId,
                        'searchux.clientVersion': 'officehomeweb',
                        'searchux.component.TriageNewsSearchResult.previewEnabled': false,
                        'searchux.currentLanguage': officeMarketLcid,
                        'searchux.debug': enableDebugOutput,
                        'searchux.enabled': true,
                        'searchux.enableQueryRules': fastEnableQueryRules,
                        'searchux.enableStartQuery': false,
                        'searchux.environment': environment,
                        'searchux.excludeBestBets': false,
                        'searchux.historyEntryDecorator': function (entry) {
                            return historyEntryDecorator(entry, rootPath);
                        },
                        'searchux.instrumenter': instrumenter,
                        'searchux.isKillSwitchActivated': function (id) {
                            return id === 'db164519-2dc9-4095-8727-98f1914f6572';
                        },
                        'searchux.isOfficePwaInUwp': isPwaInUwp || false,
                        'searchux.isTokenBasedFileThumbnailsEnabled': true,
                        'searchux.isTokenBasedProfileImagesEnabled': true,
                        'searchux.isVideoVerticalEnabled': false,
                        'searchux.locale': preferredCulture,
                        'searchux.noSourceIdForFiles': true,
                        'searchux.showDYM': serpSpellCheckEnabled,
                        'searchux.substrateSearchClientFlights': flights3s.join(','),
                        'searchux.use3SEcho': false,
                        'searchux.userEmail': userPrincipalName || '',
                        'searchux.userPrincipalName': userPrincipalName || '',
                        'searchux.userRing': 'Local',
                        'searchux.useSubstrateSearch': fastUseSubstrateEnabled,
                        'searchux.themeContexts': {
                            v9: ThemeContext_unstable,
                        },
                    };
                    enterpriseMainSettings = {
                        'searchux.substrateSuggestionsScenario': 'officehome',
                    };
                    consumerMainSettings = {
                        'searchux.substrateSuggestionsScenario': 'officehomemsa',
                        'searchux.isConsumerAllVerticalEnabled': true,
                        'searchux.isConsumerAppResultEnabled': true,
                        'searchux.isConsumerFileVerticalEnabled': true,
                        'searchux.isConsumerTemplateVerticalEnabled': true,
                        'searchux.isContextualRailEnabled': true,
                        'searchux.isSubscribedUser': isSubscribedUser,
                        'searchux.use3SPeopleSuggestions': false,
                        'searchux.use3SSiteSuggestions': false,
                        'searchux.shouldTemplateVerticalShowPremiumTemplates': true,
                    };
                    return [2 /*return*/, __assign(__assign(__assign({}, loggerSettings), baseMainSettings), (!isMsa ? enterpriseMainSettings : consumerMainSettings))];
            }
        });
    });
}
//# sourceMappingURL=getMainSettings.js.map